/** Zentrale API-Basis-URL (Build-Zeit: REACT_APP_API_URL). */
export function getApiBaseUrl() {
  const url = process.env.REACT_APP_API_URL || 'https://api.plscore.ch/';
  return url.endsWith('/') ? url : `${url}/`;
}
